const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Uploaded images are served by the backend (/api/files/...); bundled ones live in /public.
export const imgSrc = (url) => (url && url.startsWith("/api/") ? `${BACKEND}${url}` : url);
